(()=>{
  if(window.ehqMediaPerformance)return;
  window.ehqMediaPerformance=true;
  const states=new WeakMap();
  function hydrate(video){
    if(video.dataset.ehqLoaded)return;
    video.dataset.ehqLoaded='true';
    if(video.dataset.ehqPoster)video.poster=video.dataset.ehqPoster;
    for(const node of [video,...video.querySelectorAll('[data-ehq-src]')]){
      if(node.dataset.ehqSrc)node.setAttribute('src',node.dataset.ehqSrc);
    }
    video.load();
  }
  function sync(video){
    const visible=states.get(video)&&!document.hidden;
    if(!visible){video.pause();return;}
    hydrate(video);
    if(video.autoplay){video.muted=true;video.play().catch(()=>{});}
  }
  const observer=new IntersectionObserver(entries=>{
    for(const entry of entries){states.set(entry.target,entry.isIntersecting&&entry.intersectionRatio>=.15);sync(entry.target);}
  },{threshold:[0,.15]});
  function scan(root){
    for(const video of root.querySelectorAll('video[data-ehq-lazy-video]')){
      if(states.has(video))continue;
      states.set(video,false);observer.observe(video);
      video.addEventListener('pointerdown',()=>hydrate(video),{once:true});
      video.addEventListener('focus',()=>hydrate(video),{once:true});
    }
  }
  // Gallery slides after the first come without src/srcset (apply.py), so the first picture gets the bandwidth.
  // A slide gets its picture when it is shown, when the visitor touches the page, or once the page has loaded.
  function release(img){
    if(!img.hasAttribute('data-ehq-lazy-img')||img.hasAttribute('src'))return;
    imageObserver&&imageObserver.unobserve(img);
    // Fetch now, so a swipe finds the next slide ready; sizes keeps its non-auto fallback.
    img.loading='eager';
    if(img.dataset.ehqSrcset)img.setAttribute('srcset',img.dataset.ehqSrcset);
    if(img.dataset.ehqSrc)img.setAttribute('src',img.dataset.ehqSrc);
  }
  function releaseAll(){for(const img of document.querySelectorAll('img[data-ehq-lazy-img]'))release(img);}
  const imageObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    // A slide that only touches the screen edge reports isIntersecting with no area; it is not shown yet.
    for(const entry of entries)if(entry.isIntersecting&&entry.intersectionRatio>0)release(entry.target);
  },{threshold:[0.01]}):null;
  function scanImages(root){
    for(const img of root.querySelectorAll('img[data-ehq-lazy-img]:not([src])')){
      if(imageObserver)imageObserver.observe(img);else release(img);
    }
  }
  scanImages(document);
  const later=()=>(window.requestIdleCallback||setTimeout)(releaseAll,{timeout:1500});
  if(document.readyState==='complete')later();else addEventListener('load',later,{once:true});
  for(const type of ['pointerdown','touchstart','keydown'])addEventListener(type,releaseAll,{once:true,passive:true,capture:true});
  scan(document);
  document.addEventListener('shopify:section:load',event=>{scan(event.target);scanImages(event.target);});
  document.addEventListener('visibilitychange',()=>{
    for(const video of document.querySelectorAll('video[data-ehq-lazy-video]'))sync(video);
  });
})();
